/**
 * 订单详情抽屉 - 危险操作区块（取消订单）
 *
 * 系统设计口径：**订单只能取消，不能删除**。这里过去放的是「删除此订单」，
 * 而删除端点只归管理员，用户点了必然吃一个 403——按钮存在却注定失败，比没有更糟。
 * 现在它做的是 `PATCH /orders/:id/status`（置「已取消」），并保留两段式确认：
 * 取消会让这张单从列表与核算里消失，必须有一次「我是认真的」的停顿。
 *
 * 显隐由父组件按后端投影的 `canEditOrder` 决定（在途 + 建单方），本组件不自己判状态；
 * 服务端才是权威，这里挡住了只是让人少撞一次 403。
 */

interface Props {
  confirmCancel: boolean;
  cancelling: boolean;
  /** 取消失败的原文，就地显示，不弹 toast 也不静默收起确认面板 */
  error: string;
  onSetConfirmCancel: (value: boolean) => void;
  onCancel: () => void;
}

export default function DangerSection({ confirmCancel, cancelling, error, onSetConfirmCancel, onCancel }: Props) {
  return (
    <div className="pt-2">
      {!confirmCancel ? (
        <button onClick={() => onSetConfirmCancel(true)} className="w-full py-2.5 text-sm text-rose-400 border border-rose-100 rounded-lg hover:bg-rose-50 transition-colors cursor-pointer flex items-center justify-center gap-1.5">
          <div className="w-4 h-4 flex items-center justify-center"><i className="ri-close-circle-line text-sm" /></div>
          取消此订单
        </button>
      ) : (
        <div className="bg-rose-50 border border-rose-100 rounded-xl p-4 space-y-3">
          <p className="text-sm text-rose-700 font-medium">确定要取消此订单吗？</p>
          <p className="text-xs text-rose-500">取消后这张单不再出现在列表与核算中，但订单不会被删除、系统也没有回收站，无法自行恢复；如需重新记录请新建订单，确要彻底删除请联系客服。</p>
          {error && (
            <p className="text-xs text-rose-600 flex items-start gap-1.5">
              <i className="ri-error-warning-line text-xs mt-0.5 shrink-0" />
              {error}
            </p>
          )}
          <div className="flex gap-2">
            <button onClick={() => { onSetConfirmCancel(false); }} disabled={cancelling} className="flex-1 py-2 text-sm border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer whitespace-nowrap disabled:opacity-50 transition-colors">暂不取消</button>
            <button onClick={onCancel} disabled={cancelling} className="flex-1 py-2 text-sm bg-rose-500 text-white rounded-lg hover:bg-rose-600 cursor-pointer whitespace-nowrap disabled:opacity-50 transition-colors flex items-center justify-center gap-1">
              {cancelling && <i className="ri-loader-4-line animate-spin text-xs" />}确认取消
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
